<template>
    <div class="container">
        <br />
        <br />
        <div class="row justify-content-center mb-5">
            <div class="col-12">
                <router-link :to="backRoute">
                    <span class="icon icon-sm icon-glyphicons-basic-chevron-left mr-1 align-middle"></span>
                    <span class="align-middle">Back to Browse</span>
                </router-link>
            </div>
        </div>
        <div class="row publisher-container" v-if="publisher.id">
            <div class="col-12 mb-3 mb-lg-5">
                <div class="d-flex align-items-center">
                    <div class="flex-grow-0 mr-2 mr-sm-3 mr-lg-4">
                        <div class="flex-grow-0 logo-container logo-lg rounded-circle d-flex align-items-center mr-2">
                            <img
                                class="logo-circle"
                                :src="publisher.logo_file.signed_url"
                                :alt="'Logo for ' + publisher.name"
                            />
                        </div>
                    </div>
                    <div class="flex-grow-1">
                        <h2 class="h4 mb-1">{{ publisher.name }}</h2>
                        <p class="medium mb-0">
                            <a :href="publisher.website_url" target="_blank" rel="noopener">{{
                                publisher.website_url
                            }}</a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <p class="font-weight-bold form-divider-label detail-subheader medium">
                    <span class="icon mr-1 align-middle detail-header-glyph icon-glyphicons-basic-circle-info"></span>
                    <span class="align-middle">ABOUT</span>
                </p>
                <p class="community-info mb-4 pb-1">{{ publisher.description }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <hr />
                <p class="font-weight-bold form-divider-label detail-subheader medium contributions-header">
                    <span class="icon mr-1 align-middle detail-header-glyph icon-glyphicons-basic-squares"></span>
                    <span class="align-middle">Contributions</span>
                </p>
                <ul class="grid">
                    <li
                        class="d-flex flex-column item"
                        v-for="contribution in publisher.case_contributions"
                        :key="contribution.id"
                    >
                        <community-case-card :case-obj="contribution.case"></community-case-card>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import CommunityCaseCard from "@/components/CommunityCaseCard"
import Utilities from "@/assets/js/utilities.js"
import http from "@/axios.js"

export default {
    name: "CommunityPublisherDetail",
    components: {
        CommunityCaseCard,
    },
    data() {
        return {
            publisher: {
                contributions: [],
            },
            previousRoute: null,
        }
    },
    computed: {
        publisherId() {
            return this.$route.params.id
        },
        backRoute() {
            if (this.previousRoute && this.previousRoute.name === "CommunityCaseDetail") {
                // Navigate back to the case detail view.
                return this.previousRoute
            }
            let route = { name: "CommunityLibrary" }
            if (this.$store.getters.communityLibraryCategory) {
                // Route the user back to the library category they came from.
                route["query"] = {
                    tag: this.$store.getters.communityLibraryCategory
                }
            }
            return route
        },
    },
    watch: {
        publisherId: function (newValue) {
            Utilities.destroyAllPopovers()
            this.fetchData()
        },
    },
    methods: {
        fetchData() {
            this.$store.dispatch("addLoad")
            let vm = this
            http.get(`/api/community/browse/publishers/${this.publisherId}/`)
                .then(function (response) {
                    vm.publisher = response.data
                })
                .finally(function () {
                    vm.$store.dispatch("removeLoad")
                })
        },
    },
    mounted() {
        this.fetchData()
    },
    beforeDestroy() {
        // Kill all popovers.
        Utilities.destroyAllPopovers()
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.previousRoute = from
        })
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/community.scss";

.logo-container {
    cursor: initial !important;
}

.publisher-container {
    max-width: 1000px;
}

.cover-container {
    height: 170px;
    width: 270px;
}

.contributions-header {
    margin-bottom: 36px;
}

.community-content {
    max-width: 1200px;
    @media (min-width: 1420px) {
        max-width: 1550px;
    }
}

.item {
    list-style-type: none;
}

.grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
    grid-template-rows: 1fr;
    padding-inline-start: 0px;
    grid-gap: 30px;
    @media (min-width: $breakpoint-xl) {
        grid-gap: 36px;
    }
    @media (min-width: 1550px) {
        grid-gap: 38px;
    }
}
</style>